module.exports = __webpack_public_path__ + "static/media/comunidad.c884fdcf.svg";